import { Component, computed, inject } from '@angular/core';
import { LEERPLUS } from '../../rid-game.utils';
import { fromDateString, RidCalendarService } from '../../services/rid-calendar.service';

@Component({
  selector: 'rid-calendar-debug-tab',
  imports: [],
  templateUrl: './rid-calendar-debug-tab.html',
})
export class RidCalendarDebugTab {
  protected readonly $lpApiService = inject(LEERPLUS.apiToken);
  protected readonly $ridCalendarService = inject(RidCalendarService);

  protected readonly dateLabel = computed(() =>
    fromDateString(this.$ridCalendarService.today()).toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
  );

  protected readonly isDateSet = computed(() => this.$lpApiService.state().date !== null);
}
